import {Card} from 'antd';
import {ReactNode} from 'react';
import styles from './index.module.scss';

export interface IStatisticsDataItem {
  icon: ReactNode;
  title: string;
  children?: ReactNode | ReactNode[];
  color?: string;
  className?: string;
}

const StatisticsDataItem = ({
                              icon,
                              className = '',
                              title = '',
                              color = '#f05e60',
                              children,
                            }: IStatisticsDataItem) => (
  <Card
    className={`${styles.cardWrap} ${className}`}
    title={null}
    bordered={false}
  >
    <h3 style={{color}} className={styles.cardTitle}>
      {title}
    </h3>
    <div className={styles.contentWrap}>
      <span style={{color}} className={styles.icon}>
        {icon}
      </span>

      {children}
    </div>
  </Card>
);

export default StatisticsDataItem;
